import React from 'react'
import { useMemo, useCallback } from 'sb-hooks'
import { Field, useFieldState } from 'formular'
import { date } from 'common/helpers'

import { SelectableOptionView } from 'components/_new/controls'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


type FrequencyOptionProps = {
  data: ChangeFrequencyModal.Frequency
  field: Field<string>
}

const FrequencyOption: React.FunctionComponent<FrequencyOptionProps> = (props) => {
  const { data, field } = props
  const { name, shippingPeriod, nextBillingDate, nextShippingDate } = data

  const { value } = useFieldState(field)
  const checked = value === name

  const handleChange = useCallback(() => {
    field.set(name)
  }, [ field, name ])

  const titleMessage = useMemo(() => ({
    ...messages.title,
    values: {
      period: shippingPeriod,
    },
  }), [ shippingPeriod ])

  const nextShippingMessage = useMemo(() => {
    if (!nextShippingDate) {
      return null
    }

    return {
      ...messages.nextShipping,
      values: {
        date: date.formatMonth(nextShippingDate),
      },
    }
  }, [ nextShippingDate ])

  const nextBillingMessage = useMemo(() => {
    if (!nextBillingDate) {
      return null
    }

    return {
      ...messages.nextBilling,
      values: {
        date: date.formatDate(nextBillingDate, 'MMMM YYYY'),
      },
    }
  }, [ nextBillingDate ])

  return (
    <SelectableOptionView
      type="radio"
      checked={checked}
      onClick={handleChange}
      dataTestId="frequencyOption"
    >
      <Text size="16-24">
        <Text inherit semibold={Boolean(nextShippingDate)} message={titleMessage} />
        {
          Boolean(nextShippingMessage) && (
            <Text inherit color="gray-50" message={nextShippingMessage} />
          )
        }
        {
          Boolean(nextBillingMessage) && (
            <Text inherit color="gray-50" message={nextBillingMessage} />
          )
        }
      </Text>
    </SelectableOptionView>
  )
}


export default FrequencyOption
